export const TAB_CONSTANTS = {
  MORE_BUTTON_WIDTH: 42,
  GAP_PX: 4,
  INITIAL_CALC_DELAY: 250,
} as const;
